import React, { useContext, useState } from "react";
import {
  BoldLink,
  BoxContainer,
  FormContainer,
  Input,
  LineText,
  MutedLink,
  SubmitButton,
} from "./common";
import { useNavigate, Navigate } from "react-router-dom";
import { Marginer } from "../marginer";
import { AccountContext } from "./AccountContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AuthApi } from "../../../apis";

export function LoginForm(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { switchToSignup } = useContext(AccountContext);
  // Initialize formik with validation
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      setError(null);
      try {
        const res = await AuthApi.login(values);

        if (res?.data?.status === 200) {
          localStorage.setItem("token", res.data.data.token);
          localStorage.setItem("user", JSON.stringify(res.data.data.user));

          if (res.data.data.user.role_id.name === "User") {
            window.location.href = `/user/time/add/`;
          } else if (res.data.data.user.role_id.name === "Admin") {
            window.location.href = "/admin";
          } else {
            navigate("/");
          }
        } else {
          console.error("Login failed:", res?.data);
          setError(
            "Login failed. Please check your credentials and try again."
          );
        }
      } catch (err) {
        console.error("Error occurred:", err);
        setError("An error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <BoxContainer
      style={{
        width: 420,
      }}
    >
      <FormContainer onSubmit={formik.handleSubmit}>
        <Input
          type="email"
          name="email"
          placeholder="Email"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
        />
        {formik.touched.email && formik.errors.email ? (
          <div style={{ color: "red", fontSize: "12px" }}>
            {formik.errors.email}
          </div>
        ) : null}

        <Input
          type="password"
          name="password"
          placeholder="Password"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.password}
        />
        {formik.touched.password && formik.errors.password ? (
          <div style={{ color: "red", fontSize: "12px" }}>
            {formik.errors.password}
          </div>
        ) : null}
        <BoxContainer>
          <Marginer direction="vertical" margin={10} />
          <MutedLink href="#">Forget your password?</MutedLink>
          <Marginer direction="vertical" margin="1.6em" />
          <SubmitButton type="submit">Signin</SubmitButton>
        </BoxContainer>
      </FormContainer>

      <Marginer direction="vertical" margin="5px" />
      <LineText>
        Don't have an account?{" "}
        <BoldLink onClick={switchToSignup} href="#">
          Signup
        </BoldLink>
      </LineText>
    </BoxContainer>
  );
}
